var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVires(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#7EE989"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.211 359.648C364.45 402.542 313.474 430.349 256.003 430.349C159.715 430.349 81.6573 352.292 81.6573 256.003C81.6573 250.83 81.8827 245.709 82.3241 240.65H50.2199C49.8471 245.719 49.6573 250.839 49.6573 256.003C49.6573 369.965 142.042 462.349 256.003 462.349C332.185 462.349 398.725 421.065 434.47 359.648H396.211ZM429.763 270.4C430.151 265.652 430.349 260.851 430.349 256.003C430.349 159.715 352.292 81.6573 256.003 81.6573C195.047 81.6573 141.397 112.94 110.232 160.326H73.132C107.622 94.539 176.571 49.6573 256.003 49.6573C369.965 49.6573 462.349 142.041 462.349 256.003C462.349 260.843 462.182 265.643 461.855 270.4H429.763Z",
    fill: "#2E3A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.143 171.064L256.576 316.157L309.454 171.064H349.807L274.944 359.737H237.93L162.789 171.064H203.143Z",
    fill: "#2E3A59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.558 240.65H59.1777V270.399H132.558V240.65ZM385.273 270.399H453.359V240.65H385.273V270.399Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVires);
export default __webpack_public_path__ + "static/media/vires.d0821780e4d3c61e06f5954983e29096.svg";
export { ForwardRef as ReactComponent };